<div class="mt-32">
  <table class="tbl tbl--full tbl--hovered" sortable-table>
    <colgroup>
      <col width="300px" />
      <col />
      <col />
      <col width="195px" />
      <col width="175px" />
      <col width="175px" />
      <col width="100px" />
    </colgroup>
    <thead>
      <tr>
        <th>Наименование</th>
        <th>Юридический адрес</th>
        <th>Фактический адрес</th>
        <th>Номер договора</th>
        <th>Домены</th>
        <th>Период действия договора</th>
        <th>Код партнера</th>
      </tr>
    </thead>
    <tbody class="pos-r">
      <ng-container *ngIf="companiesTable.companies && companiesTable.companies.length">
        <tr *ngFor="let company of companiesTable.companies" [ngClass]="{ 'color-gray-dark': !company.is_visible }">
          <td>
            <app-role-access [action]="'disable'" [permission]="'partnership.edit'" [placement]="'bottom-left'">
              <a
                class="link"
                data-role-element
                [ngClass]="{
                  'link--gray': !company.is_visible
                }"
                [routerLink]="['/' + COMPANIES_PATHS.companies, company.ps_id]"
                id="appCompanyEdit"
              >
                {{ company.ownership_type.ot_short }}{{ ' "' + company.ps_name + '"' }}
              </a>
            </app-role-access>
          </td>
          <td>{{ company.ps_legal_address }}</td>
          <td>{{ company.ps_physical_address }}</td>
          <td>{{ company.ps_contract }}</td>
          <td>
            <span *ngFor="let last = last; let domain; of: company.domains"
              >{{ domain.domain }} <span>{{ last ? '' : ', ' }}</span></span
            >
          </td>
          <td>
            {{ company.effective_date | dateFormat: 'DD.MM.YYYY' }}
            -
            {{ company.expiration_date | dateFormat: 'DD.MM.YYYY' }}
          </td>
          <td>
            <div style="width: 100px" *ngIf="company.partner_code && company.partner_code.length > 11">
              <div class="text-ellipsis" ngbPopover="{{ company.partner_code }}" triggers="mouseenter:mouseleave" placement="bottom-right">
                {{ company.partner_code }}
              </div>
            </div>
            <div *ngIf="company.partner_code && company.partner_code.length <= 11">
              {{ company.partner_code }}
            </div>
          </td>
        </tr>
      </ng-container>
      <tr *ngIf="companiesTable.companies && !companiesTable.companies.length && !dataLoading" class="tr--reset-highlight">
        <td colspan="9">
          <div class="ta-center color-gray-dark pt-32 mt-8">
            {{ Enums.tables.emptyDataMessage }}
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="mt-32 ta-center" *ngIf="companiesTable.companies && companiesTable.companies.length">
    <button type="button" class="button" id="appShowAllCompanies" [disabled]="companiesTable.companies.length === companiesTable.count" (click)="filter.onGetCompaniesPartial()">
      Показать еще 25
    </button>
  </div>
</div>
